import { environment } from 'environments/environment';
import { BcRestApi } from 'common/api/rest-api';
import { LogModel } from 'common/logger/model/log.model';
import { LogLevel } from 'common/logger/log-level';
import { CommonAuthService } from 'common/auth/common-auth.service';

export class LoggerService {
  private static readonly WEB_WORKSPACE_LOGGER_PREFIX = 'WebWorkspace.';

  constructor(private _bcRestApi: BcRestApi, private _category: string, private _commonAuth: CommonAuthService) { }

  public logDebug(message: string, messageParams?: string[]) {
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.debug(message, messageParams);
    }

    this._sendLog(LogLevel.DEBUG, message, messageParams);
  }

  public logInfo(message: string, messageParams?: string[]) {
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.info(message, messageParams);
    }

    this._sendLog(LogLevel.INFO, message, messageParams);
  }

  public logError(message: string, messageParams?: string[]) {
    console.error(message, messageParams);
    this._sendLog(LogLevel.ERROR, message, messageParams);
  }

  public logWarn(message: string, messageParams?: string[]) {
    console.warn(message, messageParams);
    this._sendLog(LogLevel.WARN, message, messageParams);
  }

  private async _sendLog(logLevel: LogLevel, message: string, messageParams?: string[]): Promise<void> {
    const logRequest: LogModel = {
      category: LoggerService.WEB_WORKSPACE_LOGGER_PREFIX + this._category,
      logLevel: logLevel,
      message: message,
      messageParams: messageParams
    };

    if (await this._commonAuth.isBoldEnabled() && this._bcRestApi.isInitialized()) {
      this._bcRestApi.sendLog(logRequest);
    }
  }
}
